import { render, staticRenderFns } from "./trust.vue?vue&type=template&id=4b05ab90&scoped=true"
import script from "./trust.vue?vue&type=script&lang=js"
export * from "./trust.vue?vue&type=script&lang=js"
import style0 from "./trust.vue?vue&type=style&index=0&id=4b05ab90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05ab90",
  null
  
)

export default component.exports